import { createSlice } from "@reduxjs/toolkit";

export const loanEligibilitySlice = createSlice({
    name: "loanEligibility",
    initialState: {
        error: "Sorry! No Data Found.",
        message: null,
        loading: false,
        model: false,
        drawer: false,
        error_msg: null,
        listCount: 0,
        eligibilityList: [],
        eligibilityParams: {
            start_date: "",
            end_date: "",
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "created_at",
            sortOrder: "-",
        },
        rowdata: {},
        eligibilityViewData: {},
        viewModel: false,
        loanProducts: [],
        loanProductsLoading: false,
        mobileLookupLoading: false,
        panLookupLoading: false,
        config: null,
        configLoading: false,
        usageData: null,
        usageLoading: false,
    },
    reducers: {
        clearEligibilityData: (state, action) => {
            return {
                ...state,
                loading: false,
                eligibilityList: [],
                rowdata: {},
            }
        },
        getEligibilityList: (state, action) => {
            if (state.eligibilityParams?.page == 1) {
                return {
                    ...state,
                    loading: true,
                    eligibilityList: [],
                };
            } else {
                return {
                    ...state,
                    loading: true,
                };
            }
        },
        eligibilityListSuccessful: (state, action) => {
            var response = action.payload;
            var list = [];
            if (state.eligibilityParams?.page == 1) {
                list = response.results;
            } else {
                list = response.results;
            }
            var noofpages = Math.ceil(
                action.payload.count / state.eligibilityParams?.page_size
            );
            return {
                ...state,
                eligibilityList: list,
                listCount: action.payload.count,
                loading: false,
                eligibilityParams: {
                    ...state.eligibilityParams,
                    no_of_pages: noofpages,
                },
            };
        },
        SetEligibilityParams: (state, action) => {
            return {
                ...state,
                eligibilityParams: action.payload,
            };
        },
        getEligibilityByID: (state) => {
            return {
                ...state,
                loading: true,
                rowdata: {},
            };
        },
        eligibilityCheckAdd: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        eligibilityByIDSuccessful: (state, action) => {
            const response = action.payload.response;
            return {
                ...state,
                loading: false,
                rowdata: response,
                model: action.payload.type === "update",
                viewModel: action.payload.type === "view",
                eligibilityViewData: response,
            };
        },
        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },
        isModelVisible: (state, action) => {
            if (action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                    eligibilityViewData: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                    eligibilityViewData: {},
                };
            }
        },
        isViewModelVisible: (state, action) => {
            if (action.payload) {
                return {
                    ...state,
                    viewModel: action.payload,
                    eligibilityViewData: {},
                };
            } else {
                return {
                    ...state,
                    viewModel: action.payload,
                };
            }
        },
        isDrawerVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    drawer: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    drawer: action.payload,
                };
            }
        },
        FilterInputChangeValue: (state, action) => {
            return {
                ...state,
                eligibilityParams: {
                    ...state.eligibilityParams,
                    [action.payload.key]: action.payload.value,
                },
            };
        },
        apiError: (state, action) => {
            return {
                ...state,
                loading: false,
                error_msg: action.payload,
            };
        },
        getLoanProducts: (state) => {
            return {
                ...state,
                loanProductsLoading: true,
            };
        },
        loanProductsSuccessful: (state, action) => {
            return {
                ...state,
                loanProducts: action.payload,
                loanProductsLoading: false,
            };
        },
        mobileLookup: (state) => {
            return {
                ...state,
                mobileLookupLoading: true,
            };
        },
        mobileLookupSuccessful: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    ...action.payload,
                },
                mobileLookupLoading: false,
            };
        },
        mobileLookupError: (state) => {
            return {
                ...state,
                mobileLookupLoading: false,
            };
        },
        panLookup: (state) => {
            return {
                ...state,
                panLookupLoading: true,
            };
        },
        panLookupSuccessful: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    ...action.payload,
                },
                panLookupLoading: false,
            };
        },
        panLookupError: (state) => {
            return {
                ...state,
                panLookupLoading: false,
            };
        },
        getConfig: (state) => {
            return {
                ...state,
                configLoading: true,
            };
        },
        configSuccessful: (state, action) => {
            return {
                ...state,
                config: action.payload,
                configLoading: false,
            };
        },
        configError: (state) => {
            return {
                ...state,
                configLoading: false,
            };
        },
        getUsage: (state) => {
            return {
                ...state,
                usageLoading: true,
            };
        },
        usageSuccessful: (state, action) => {
            return {
                ...state,
                usageData: action.payload,
                usageLoading: false,
            };
        },
        usageError: (state) => {
            return {
                ...state,
                usageLoading: false,
            };
        },
    },
});

export const {
    getEligibilityList,
    eligibilityListSuccessful,
    SetEligibilityParams,
    getEligibilityByID,
    eligibilityByIDSuccessful,
    eligibilityCheckAdd,
    InputChangeValue,
    isModelVisible,
    isDrawerVisible,
    FilterInputChangeValue,
    isViewModelVisible,
    clearEligibilityData,
    apiError,
    getLoanProducts,
    loanProductsSuccessful,
    mobileLookup,
    mobileLookupSuccessful,
    mobileLookupError,
    panLookup,
    panLookupSuccessful,
    panLookupError,
    getConfig,
    configSuccessful,
    configError,
    getUsage,
    usageSuccessful,
    usageError,
} = loanEligibilitySlice.actions;

export default loanEligibilitySlice.reducer;
